import { Heading } from "./Heading";
import { Pill } from "./Pill";

/**
 * Centered or left-aligned section header with tag, title, and optional subtitle.
 *
 * @param {Object} props
 * @param {string} [props.tag] - small label rendered as an eyebrow pill above the title
 * @param {import("react").ReactNode} props.title - h2 heading content
 * @param {string} [props.subtitle] - paragraph rendered below the title
 * @param {"center" | "left"} [props.align] - alignment, defaults to center
 * @param {string} [props.className] - extra classes on the wrapper
 * @returns {import("react").ReactElement}
 */
export function SectionHeader(props) {
  const { tag, title, subtitle, align = "center", className = "" } = props;

  const alignClass = align === "center" ? "text-center items-center" : "text-left items-start";

  return (
    <div className={`flex flex-col ${alignClass} mb-12 gap-4 md:mb-14 ${className}`.trim()}>
      {tag ? <Pill variant="eyebrow">{tag}</Pill> : null}
      <Heading size="section" className="text-ink max-w-3xl">
        {title}
      </Heading>
      {subtitle ? <p className="body-lg text-muted max-w-2xl">{subtitle}</p> : null}
    </div>
  );
}
